import React from 'react';
import { usePageBreadcrumbs } from '../app.use/usePageBreadcrumbs';
// import { systemUI } from '../utils.styles/system';
import { GlobalRegistry } from '../pkg.syncregistry/GlobalRegistry';

export function PageBreadcrumbsView(props: {}) {
  const pageBreadcrumbs = usePageBreadcrumbs();
  const hasBreadcrumbs = !!pageBreadcrumbs.length;
  if (hasBreadcrumbs) {
    return <GlobalRegistry use="page.breadcrumbs" items={pageBreadcrumbs} />;
  }
  return null;
}
